<div class="table table-striped">
  <p-table #dt [value]="direcciones" [rows]="10" [paginator]="true" [globalFilterFields]="['claseNavigation.descripcion','calle']" 
               [rowHover]="true" dataKey="id" 
               currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} direcciones" [showCurrentPageReport]="true">
    <ng-template pTemplate="caption">
      <div class="p-d-flex p-ai-center p-jc-between">
        <span class="p-input-icon-left">
          <!-- <i class="pi pi-search"></i> -->
          <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')" placeholder="Buscar..." />
        </span>
        <span class="p-input-icon">
          Vigencias del  
         <input pInputText type="date" [(ngModel)]="filtroDesde" (ngModelChange)="onChangeFiltros()" style="text-align:center" [disabled]="agrupar">
          al  
         <input pInputText type="date" [(ngModel)]="filtroHasta" (ngModelChange)="onChangeFiltros()" style="text-align:center" [disabled]="agrupar">
        </span>
        <mat-slide-toggle color="primary" [(ngModel)]="agrupar" (ngModelChange)="onChangeAgrupamiento()">Agrupar</mat-slide-toggle>
        <button *ngIf="permisoEdicion" type="button" pButton pRipple pTooltip="Agregar" tooltipPosition="bottom" icon="pi pi-plus" class="btn btn-sm btn-primary pull-right" (click)='add()'></button>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th>Clase</th>
        <th>Calle</th>
        <th>Nro</th>
        <th>Piso</th>
        <th>Depto</th>
        <th>Localidad</th>
        <th>Cod Pos</th>
        <th>Provincia</th>
        <th>Teléfono</th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-direccion let-rowIndex="rowIndex">
      <tr>
        <td>{{direccion.claseNavigation.descripcion}}</td>
        <td>{{direccion.calle}}</td>
        <td>{{direccion.nro}}</td>
        <td>{{direccion.piso}}</td>
        <td>{{direccion.dpto}}</td>
        <td>{{direccion.localidad}}</td>
        <td>{{direccion.codPos}}</td>
        <td>{{direccion.provinciaNavigation.descripcion}}</td>
        <td>{{direccion.telefono}}</td>
        <td>
          <button pButton pRipple pTooltip="Editar" tooltipPosition="bottom" icon="pi pi-pencil" class="btn btn-xs btn-warning" (click)="visualizarDetalle(direccion, rowIndex)"></button>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
